<div class="container">
  <div class="row">
    <div class="col-8 text-nowrap">Aircraft stand:</div>
    <div class="col-4 text-nowrap">{{stand ? stand : 'none'}}</div>
    <div class="col-8 text-nowrap">Passenger gate:</div>
    <div class="col-4 text-nowrap">{{gate ? gate : 'none'}}</div>
  </div>
</div>
